import { List, Create, Edit, View } from "../Components/index.js";

export default [
    {
        path: "/complaint",
        component: List,
        name: "complaint-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/complaint/:code/edit",
        component: Edit,
        name: "complaint-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/complaint/:code/view",
        component: View,
        name: "complaint-view",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/complaint/create",
        component: Create,
        name: "complaint-create",
        meta: {
            requiresAuth: true,
        },
    },
];
